module.exports = __webpack_public_path__ + "static/img/t5.d10bba7c.png";